import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Pet, Utils, EventInput, TeamMemberColor } from '@gv/triage-components';

import { mergeSlots } from 'pages/calendar/view/dialogs/config';

type Events = EventInput[];

const { joinStrings } = Utils.Helpers;

dayjs.extend(utc);

dayjs.extend(timezone);

export const generateItems = (
  clinicHours?: any,
  isAppointment?: boolean,
  dynamicstartDate?: any
) => {
  const {
    bitwerx,
    Timezone,
    schedule,
    vetspire,
    resources,
    clinichours,
    bitwerx_rooms,
    availabilities,
    schedule_matrix,
    isBitwerxEnabled,
    isVetsPireEnabled,
    bitwerx_providers,
    pimsExistingBlocks,
    appointment_statuses,
    appointmentLength = 10,
    clinicHoursAppointment,
    pimsExistingAppointments,
    timezone: originalTimeZone,
    bitwerx_slots: biitwerxAvailableSlots,
  } = clinicHours ?? {};
  const useTimezone = originalTimeZone ?? Timezone;
  const timezoneOptions = {
    timeZone: useTimezone && useTimezone.time_zone_code,
  };
  const events: Events = [];
  const items: any[] = clinichours ?? schedule ?? availabilities?.rows ?? [];
  const appointments: any[] = clinicHoursAppointment ?? [];
  const isActionCenterURL = location.pathname.includes('action-center');
  // const isActionCenterURL = true;
  const bookedTimeStamps = new Set<string>();
  items.forEach((item) => {
    if (isAppointment && item?.appointment_type_id) {
      const currentMatrix = schedule_matrix.find(
        (sm: any) => sm.id === item.appointment_type_id
      );
      if (currentMatrix) {
        if (currentMatrix?.appointmentType?.reason_id !== item?.reason_id) {
          const matchingMatrix = schedule_matrix.find(
            (sm: any) => sm?.appointmentType?.reason_id === item?.reason_id
          );
          if (matchingMatrix) {
            item.appointment_type_id = matchingMatrix.id;
          } else {
            delete item.appointment_type_id;
          }
        }
      } else {
        delete item.appointment_type_id;
      }
    }
    const {
      client,
      doctor,
      status,
      case_id,
      group_id,
      client_id,
      doctor_id,
      dvm_user_id,
      appointment,
      description,
      end: endDates,
      start: startDates,
      time_slots: timeslots,
    } = item;

    if (startDates && endDates) {
      startDates.forEach((start: number[], index: number) => {
        const end = endDates[index];
        const startDate = new Date(Number(start)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const endDate = new Date(Number(end)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const extendedProps: Record<string, any> = {
          item,
          timeslots,
          end: endDate,
          endSlot: end,
          bitwerx_rooms,
          start: startDate,
          isBitwerxEnabled,
          startSlot: start,
          isVetsPireEnabled,
          bitwerx_providers,
          groupId: group_id,
          appointment_statuses,
          isGrouped: !!group_id,
          timezone: useTimezone,
          isClinicAppointment: false,
          color: TeamMemberColor.Green,
        };
        if (isBitwerxEnabled) {
          extendedProps.bitwerx = bitwerx;
        }
        if (isVetsPireEnabled) {
          extendedProps.vetspire = vetspire;
        }
        if (doctor) {
          extendedProps.docName = doctor.name;
        }
        if (appointment) {
          extendedProps.chatId = appointment.createdChatId;
        }
        if (case_id) {
          extendedProps.case_id = case_id;
        }
        if (status != null || status !== undefined) {
          extendedProps.status = Number(status);
        }
        let title = item?.title;
        if (isAppointment) {
          extendedProps.isAppointment = true;
          title =
            'Client Name: ' +
              (item?.client?.name ? item?.client?.name : 'Null') +
              ', ' +
              'Client Phone: ' +
              (item?.client?.phones?.[0] ? item?.client?.phones?.[0] : 'Null') +
              ', ' +
              'Pet Name: ' +
              (item?.pet?.name ? item?.pet?.name : 'Null') +
              ', ' +
              'Pet Breed: ' +
              (item?.pet?.breed ? item?.pet?.breed : 'Null') +
              ', ' +
              'Pet Species: ' +
              (item?.pet?.species ? item?.pet?.species : 'Null') || item.title;
        }
        if (client_id) {
          extendedProps.clientId = client_id;
          if (client) {
            extendedProps.client = {
              name: client.name,
              phone: client.phone,
              email: client?.email,
              description: description,
              pets: appointment?.task?.pets?.map((pet: Pet) =>
                joinStrings([pet?.name, pet?.species], ', ')
              ),
            };
          }
        }
        if (startDate && dayjs(startDate).isBefore(dayjs())) {
          extendedProps.isPastSlots = true;
        } else {
          extendedProps.isPastSlots = false;
        }
        if (doctor_id) {
          extendedProps.docId = doctor_id;
        } else if (dvm_user_id) {
          extendedProps.docId = dvm_user_id;
        }
        // const OTHERS_RESOURCE_ID = 'Z_Other_source_id'; // Must match the ID used in resources array
        let resourceId = item?.provider_id;
        // if (resources && resources.length > 0) {
        //   const resourceIds = resources.map((r: any) => r.id);
        //   // Check if resourceId exists in resources
        //   if (
        //     resourceId === null ||
        //     resourceId === undefined ||
        //     !resourceIds.includes(resourceId)
        //   ) {
        //     resourceId = OTHERS_RESOURCE_ID;
        //   }
        // } else if (resourceId === null || resourceId === undefined) {
        //   resourceId = OTHERS_RESOURCE_ID;
        // }
        const event: EventInput = {
          title: title,
          extendedProps,
          id: String(item.id),
          resourceId: resourceId,
        };
        bookedTimeStamps.add(startDate);
        events.push(event);
      });
    }
  });

  pimsExistingAppointments?.forEach((item: any) => {
    const {
      client,
      group_id,
      client_id,
      appointment,
      description,
      end: endDates,
      start: startDates,
      time_slots: timeslots,
    } = item;

    if (startDates && endDates) {
      startDates.forEach((start: number[], index: number) => {
        const end = endDates[index];
        const startDate = new Date(Number(start)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const endDate = new Date(Number(end)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const extendedProps: Record<string, any> = {
          item,
          timeslots,
          status: 1,
          end: endDate,
          endSlot: end,
          bitwerx_rooms,
          start: startDate,
          isBitwerxEnabled,
          startSlot: start,
          isVetsPireEnabled,
          bitwerx_providers,
          groupId: group_id,
          appointment_statuses,
          isGrouped: !!group_id,
          timezone: useTimezone,
          isClinicAppointment: false,
          isOnlyPimsAppointment: true,
          color: TeamMemberColor.Green,
        };
        if (isBitwerxEnabled) {
          extendedProps.bitwerx = bitwerx;
        }
        if (isVetsPireEnabled) {
          extendedProps.vetspire = bitwerx;
        }

        extendedProps.case_id = 'No Case ID';

        if (isAppointment) {
          extendedProps.isAppointment = true;
        }
        if (client_id) {
          extendedProps.clientId = client_id;
          if (client) {
            extendedProps.client = {
              name: client.name,
              phone: client.phone,
              email: client?.email,
              description: description,
              pets: appointment?.task?.pets?.map((pet: Pet) =>
                joinStrings([pet?.name, pet?.species], ', ')
              ),
            };
          }
        }

        // Check if provider_id exists in resources, if not assign to "Others"
        // const OTHERS_RESOURCE_ID = 'Z_Other_source_id'; // Must match the ID used in resources array
        let resourceId = item?.provider_id;
        // if (resources && resources.length > 0) {
        //   const resourceIds = resources.map((r: any) => r.id);
        //   // Check if resourceId exists in resources
        //   if (
        //     resourceId === null ||
        //     resourceId === undefined ||
        //     !resourceIds.includes(resourceId)
        //   ) {
        //     resourceId = OTHERS_RESOURCE_ID;
        //   }
        // } else if (resourceId === null || resourceId === undefined) {
        //   resourceId = OTHERS_RESOURCE_ID;
        // }

        const event: EventInput = {
          extendedProps,
          resourceId: resourceId,
          id: 'PIMS-' + String(item.id),
          title:
            'Client Name: ' +
            (item?.client?.name ? item?.client?.name : 'Null') +
            ', ' +
            'Client Phone: ' +
            (item?.client?.phones?.[0] ? item?.client?.phones?.[0] : 'Null') +
            ', ' +
            'Pet Name: ' +
            (item?.pet?.name ? item?.pet?.name : 'Null') +
            ', ' +
            'Pet Breed: ' +
            (item?.pet?.breed ? item?.pet?.breed : 'Null') +
            ', ' +
            'Pet Species: ' +
            (item?.pet?.species ? item?.pet?.species : 'Null'),
        };
        bookedTimeStamps.add(startDate);
        events.push(event);
      });
    }
  });

  pimsExistingBlocks?.forEach((item: any) => {
    const { end: endDates, start: startDates, time_slots: timeslots } = item;

    const startDate = new Date(Number(startDates)).toLocaleString(
      'en-US',
      timezoneOptions
    );
    const endDate = new Date(Number(endDates)).toLocaleString(
      'en-US',
      timezoneOptions
    );
    if (isActionCenterURL) {
      const mappedTitle =
        item?.title || item?.pet?.name || item?.appointment?.title || '';

      const event = {
        bitwerx,
        item: item,
        doctors: '',
        end: endDate,
        bitwerx_rooms,
        isBlock: !true,
        isBooked: false,
        start: startDate,
        isBitwerxEnabled,
        isVetsPireEnabled,
        bitwerx_providers,
        title: mappedTitle,
        endSlot: endDates[0],
        appointment_statuses,
        timeslots: timeslots,
        timezone: useTimezone,
        isAvailableSlots: true,
        startSlot: startDates[0],
        isClinicAppointment: false,
        color: TeamMemberColor.Blue,
        isPimsExistingAppointment: true,
      };

      events.push({
        color: event.color,
        title: event.title,
        extendedProps: event,
        borderColor: '#c5b9b9ff',
        resourceId: item?.provider_id,
        id: `${startDates}-${endDates}-${item?.provider_id}`, // make id unique
      });
    }
  });

  if (isAppointment) {
    const appointmentsByDate: any = {};

    appointments.forEach((item) => {
      const { start } = item;
      const appointmentDate = dayjs(start[0])
        .tz(useTimezone.time_zone_code)
        .format('YYYY-MM-DD');

      if (!appointmentsByDate[appointmentDate]) {
        appointmentsByDate[appointmentDate] = [];
      }
      appointmentsByDate[appointmentDate].push(item);
    });

    const dynamicDateData = dynamicstartDate
      ? dynamicstartDate.replace(/\//g, '-')
      : '2024-08-16';

    const today = dayjs(dynamicDateData).tz(useTimezone.time_zone_code);
    const sunday = today.startOf('week').day(0);
    const weekRange = [];

    for (let i = 0; i < 7; i++) {
      weekRange.push(sunday.clone().add(i, 'day').format('YYYY-MM-DD'));
    }

    weekRange.forEach((date) => {
      if (!appointmentsByDate[date]) {
        const startOfDay = dayjs
          .tz(`${date} 00:00`, useTimezone.time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');
        const endOfDay = dayjs
          .tz(`${date} 23:59`, useTimezone.time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');
        if (!isBitwerxEnabled && !isVetsPireEnabled) {
          const newSlot = {
            timeslots: [],
            end: endOfDay,
            isBlock: false,
            start: startOfDay,
            timezone: useTimezone,
            isClinicAppointment: true,
            color: TeamMemberColor.Red,
          };

          events.push({
            extendedProps: newSlot,
            id: `${date}-full-day`,
            title: 'Booking Not Available',
          });
        }
      }
    });

    if (isActionCenterURL && biitwerxAvailableSlots?.length > 0) {
      biitwerxAvailableSlots.sort(
        (a: any, b: any) =>
          dayjs(a.startTime).valueOf() - dayjs(b.startTime).valueOf()
      );

      const slots = mergeSlots(
        biitwerxAvailableSlots,
        appointmentLength || 10,
        10
      );
      slots.forEach((slot: any) => {
        const { endTime, startTime, doctorNames } = slot;

        const isAvailable = doctorNames && doctorNames?.length > 0;

        const timeslotsValues = [[startTime, endTime]];

        const startDate = new Date(Number(startTime)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        const endDate = new Date(Number(endTime)).toLocaleString(
          'en-US',
          timezoneOptions
        );
        if (isActionCenterURL) {
          const event = {
            bitwerx,
            title: '',
            end: endDate,
            bitwerx_rooms,
            isBooked: false,
            start: startDate,
            endSlot: endTime,
            isBitwerxEnabled,
            color: '#ffffff',
            isVetsPireEnabled,
            bitwerx_providers,
            appointment_statuses,
            doctors: doctorNames,
            startSlot: startTime,
            isBlock: !isAvailable,
            timezone: useTimezone,
            isClinicAppointment: false,
            timeslots: timeslotsValues,
            isAvailableSlots: isAvailable,
          };

          slot?.doctorNames?.forEach((doctor: any) => {
            const doctorEvent = {
              ...event,
              doctors: [doctor],
              providerId: doctor?.ProviderId,
              resourceId: doctor?.ProviderId,
            };
            events.push({
              color: '#ffffff',
              textColor: '#0e4380ff',
              borderColor: '#c5b9b9ff',
              title: doctorEvent.title,
              backgroundColor: '#ffffff',
              extendedProps: doctorEvent,
              resourceId: doctor.ProviderId,
              id: `${startTime}-${endTime}-${doctor.ProviderId}`, // make id unique
            });
          });
        }
      });
    }

    Object.keys(appointmentsByDate).forEach((date) => {
      const appointmentsOnDate = appointmentsByDate[date];

      appointmentsOnDate?.sort((a: any, b: any) => a.start[0] - b.start[0]);

      let startOfDay = dayjs
        .tz(`${date} 00:00`, useTimezone.time_zone_code)
        .valueOf();
      const endOfDay = dayjs
        .tz(`${date} 23:59`, useTimezone.time_zone_code)
        .valueOf();

      appointmentsOnDate.forEach((item: any) => {
        const { end, start } = item;

        const startSlot = dayjs(start[0])
          .tz(useTimezone.time_zone_code)
          .valueOf();
        const endSlot = dayjs(end[0]).tz(useTimezone.time_zone_code).valueOf();

        if (startSlot > startOfDay) {
          const newSlot = {
            endSlot,
            startSlot,
            timeslots: [],
            color: 'gray',
            isBlock: false,
            timezone: useTimezone,
            isClinicAppointment: true,
            end: dayjs(startSlot)
              .tz(useTimezone.time_zone_code)
              .format('YYYY-MM-DD HH:mm:ss'),
            start: dayjs(startOfDay)
              .tz(useTimezone.time_zone_code)
              .format('YYYY-MM-DD HH:mm:ss'),
          };

          events.push({
            extendedProps: newSlot,
            color: TeamMemberColor.Red,
            id: `${date}-${startOfDay}`,
            title: 'Booking Not Available',
          });
        }
        startOfDay = endSlot;
      });

      if (startOfDay < endOfDay) {
        const newSlot = {
          timeslots: [],
          isBlock: false,
          timezone: useTimezone,
          isClinicAppointment: true,
          color: TeamMemberColor.Red,
          end: dayjs(endOfDay)
            .tz(useTimezone.time_zone_code)
            .format('YYYY-MM-DD HH:mm:ss'),
          start: dayjs(startOfDay)
            .tz(useTimezone.time_zone_code)
            .format('YYYY-MM-DD HH:mm:ss'),
        };

        events.push({
          extendedProps: newSlot,
          id: `${date}-${startOfDay}`,
          title: 'Booking Not Available',
        });
      }
    });
  }
  // Function to find empty slots (slots without events) for each resource
  const findEmptySlots = (
    allEvents: Events,
    slotDurationMinutes: number = 1,
    selectedDate?: any
  ): any => {
    const emptySlotEvents: EventInput[] = [];

    const eventsByResource = new Map<string, EventInput[]>();

    resources?.forEach((r: any) => {
      eventsByResource.set(String(r.id), []);
    });

    allEvents?.forEach((event: EventInput) => {
      if (!event.resourceId) {
        return;
      }
      const key = String(event.resourceId);
      if (eventsByResource.has(key)) {
        eventsByResource.get(key)!.push(event);
      }
    });
    const baseDate = selectedDate
      ? dayjs.tz(selectedDate, 'YYYY-MM-DD', useTimezone?.time_zone_code)
      : dayjs().tz(useTimezone?.time_zone_code);

    const dayStart = baseDate.startOf('day').valueOf();
    const dayEnd = baseDate.endOf('day').valueOf();

    const slotDuration = slotDurationMinutes * 60 * 1000;

    eventsByResource.forEach((resourceEvents, resourceId) => {
      const timeRanges: any[] = [];

      resourceEvents.forEach((event) => {
        const ep = event.extendedProps || {};
        const start = ep.startSlot
          ? dayjs
              .tz(
                ep.startSlot,
                'MM/DD/YYYY, hh:mm:ss A',
                useTimezone?.time_zone_code
              )
              .valueOf()
          : event.start instanceof Date
            ? event.start.getTime()
            : typeof event.start === 'number'
              ? event.start
              : dayjs(event.start as string).valueOf();

        const end = ep.endSlot
          ? dayjs
              .tz(
                ep.endSlot,
                'MM/DD/YYYY, hh:mm:ss A',
                useTimezone?.time_zone_code
              )
              .valueOf()
          : event.end instanceof Date
            ? event.end.getTime()
            : typeof event.end === 'number'
              ? event.end
              : dayjs(event.end as string).valueOf();

        timeRanges.push({ end, start });
      });

      const dayEvents = timeRanges.filter(
        (r) => r.start < dayEnd && r.end > dayStart
      );

      let cursor: any = dayStart;
      const emptySlots: any[] = [];

      while (cursor + slotDuration <= dayEnd) {
        const slotStart = cursor;
        const slotEnd = slotStart + slotDuration;

        const hasOverlap = dayEvents.some(
          (ev) => slotStart < ev.end && slotEnd > ev.start
        );

        if (!hasOverlap) {
          emptySlots.push({ end: slotEnd, start: slotStart });
        }

        cursor = slotEnd;
      }

      if (!emptySlots.length) {
        return;
      }

      let mergedStart = emptySlots[0].start;
      let mergedEnd = emptySlots[0].end;
      function pushEmptyEvent(start: number, end: number, resourceId1: string) {
        emptySlotEvents.push({
          title: '',
          color: '#f0f0f0',
          textColor: '#2b2b2b',
          resourceId: resourceId1,
          backgroundColor: '#f1ebebc5',
          id: `empty-${start}-${end}-${resourceId1}`,
          extendedProps: {
            endSlot: end,
            bitwerx_rooms,
            isBlock: false,
            isBooked: false,
            startSlot: start,
            isBitwerxEnabled,
            isEmptySlot: true,
            bitwerx_providers,
            isVetsPireEnabled,
            appointment_statuses,
            timezone: useTimezone,
            isClinicAppointment: false,
            end: new Date(end).toLocaleString('en-US', timezoneOptions),
            start: new Date(start).toLocaleString('en-US', timezoneOptions),
          },
        });
      }
      for (let i = 1; i < emptySlots.length; i++) {
        const curr = emptySlots[i];

        if (curr.start === mergedEnd) {
          mergedEnd = curr.end;
        } else {
          pushEmptyEvent(mergedStart, mergedEnd, resourceId);
          mergedStart = curr.start;
          mergedEnd = curr.end;
        }
      }

      pushEmptyEvent(mergedStart, mergedEnd, resourceId);
    });
    return emptySlotEvents;
  };

  const selectedDateForEmptySlots =
    dynamicstartDate ||
    (clinicHours?.start
      ? dayjs(clinicHours.start).format('YYYY-MM-DD')
      : undefined);
  let emptySlots: any = [];

  if (
    isActionCenterURL &&
    isAppointment &&
    (isBitwerxEnabled || isVetsPireEnabled)
  ) {
    emptySlots = findEmptySlots(events, 1, selectedDateForEmptySlots);
  }
  const events1 = [...events, ...emptySlots];
  return { events: events1, timezone: useTimezone };
};
